import {
    selectAndMergePhysiotherapyMgrReferralQuestionnaireConfigFactory,
    selectAndMergePhysiotherapySelfReferralQuestionnaireConfigFactory
} from "@teamprevent/common/questionnaires/questionnaireConfig/selectors";
import {
    masterConfig as physiotherapySelfReferralManagerMasterConfig
} from "@teamprevent/common/questionnaires/questionnaireConfig/physiotherapySelfReferral/masterConfig";
import {
    masterConfig as physiotherapyMgrReferralManagerMasterConfig
} from "@teamprevent/common/questionnaires/questionnaireConfig/physiotherapyMgrReferral/masterConfig";

import { ApplicationState } from "../applicationState";

export const selectAndMergePhysiotherapyMgrReferralQuestionnaireConfig =
    selectAndMergePhysiotherapyMgrReferralQuestionnaireConfigFactory<ApplicationState>(
        physiotherapyMgrReferralManagerMasterConfig,
        (state) => state.questionnaireConfig.physiotherapyMgrReferral
    );

export const selectAndMergePhysiotherapySelfReferralQuestionnaireConfig =
    selectAndMergePhysiotherapySelfReferralQuestionnaireConfigFactory<ApplicationState>(
        physiotherapySelfReferralManagerMasterConfig,
        (state) => state.questionnaireConfig.physiotherapySelfReferral
    );
